'use client';

import { PageMain } from '@/app/(app)/page-main';
import { EmployeesTable } from '@/app/(app)/settings/employees/table/table';

export function EmployeesPage() {
  return (
    <PageMain title='Employees'>
      <EmployeesTable />
    </PageMain>
  );
}
